let toggleItemDetails = function() {
    let checkedItem = jQuery('input[name=LoanPurchase]:checked'),
        selectedValue = checkedItem.length ? checkedItem.val() : '';

    jQuery('.show-can-security').toggleClass('d-none', (['car','motorbike', 'boat', 'other'].indexOf(selectedValue) === -1));
    jQuery('.show-if-description').toggleClass('d-none', (['other','refinancing'].indexOf(selectedValue) === -1));
    jQuery('.show-if-number-plate').toggleClass('d-none', (['car','motorbike'].indexOf(selectedValue) === -1));
    jQuery('.show-if-website').toggleClass('d-none', (['car','motorbike', 'boat'].indexOf(selectedValue) === -1));
};

jQuery( document ).ready(function() {
    jQuery('input[name=LoanPurchase]').on('keyup change blur keypress', toggleItemDetails);

    toggleItemDetails();
});